import PropTypes from 'prop-types';

const CustomImage = ({ src, style, className, alt, onClick, dataTestId = '' }) => {
  const onError = (e) => {
    const path = src.split('/assets')[1];
    e.target.onerror = null;
    e.target.src = `/assets${path}`;
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick?.(e); // Fare tıklamasını klavye desteğine bağla
    }
  };
  return (
    <img
      data-testid={dataTestId}
      style={style}
      src={src}
      className={className}
      alt={alt || 'image'}
      onClick={onClick}
      onKeyDown={handleKeyPress}
      onError={onError}
    />
  );
};

CustomImage.propTypes = {
  src: PropTypes.string,
  style: PropTypes.any,
  className: PropTypes.string,
  alt: PropTypes.string,
  onClick: PropTypes.any,
  dataTestId: PropTypes.string,
};

export default CustomImage;
